import {checkUrlParam} from "../utils/url";

export const FACEBOOK_INDICATOR_ELEMENT = document.querySelector('#fbPixelIndicator');

export const importFacebookTracker = () => {
    if (FACEBOOK_INDICATOR_ELEMENT && FACEBOOK_INDICATOR_ELEMENT.value === 'enabled') {
        const facebookPixelId = checkUrlParam('fbqid');
        if (facebookPixelId) {
            addFacebookPixelScript();
        }
    }
}

const addFacebookPixelScript = () => {
    const script = document.createElement('script');
    script.innerHTML = `!function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');`;
    document.body.appendChild(script);
    return true;
};

const trackFacebook = id => {
    const event = checkUrlParam('fbev') || 'Lead';
    window.fbq('init', id);
    window.fbq('track', event)
}

export const handleFacebookPixel = () => {
    if (FACEBOOK_INDICATOR_ELEMENT && FACEBOOK_INDICATOR_ELEMENT.value === 'enabled') {
        const facebookPixelId = checkUrlParam('fbqid');
        if (facebookPixelId) {
            trackFacebook(facebookPixelId);
        }
    }
}